import React from 'react';
import InfoIcon from '@atlaskit/icon/glyph/info';
import Tooltip from '@atlaskit/tooltip';
import './cell-with-info-icon.scss';

const CellWithInfoIcon = ({ cellName, tooltipText }: { cellName: string; tooltipText: string }) => {
  return (
    <th>
      <Tooltip content={tooltipText} tag="span">
        <InfoIcon label="Info" size="small" />
      </Tooltip>
      <span className="cell-name">{cellName}</span>
    </th>
  );
};

export default CellWithInfoIcon;
